import { getApi } from '@/service/api';

export const RECAPTCHA_V2_REQUIRED = 'recaptcha_v2_required';

export default class Dao {
  constructor() {
    this.api = getApi();
  }

  handleError(err) {
    // The response interceptor in api.js rejects with a plain object
    // { status, detail } so we prefer err.detail; fall back to the raw
    // response shape for callers that bypass the interceptor.
    const detail = err.detail !== undefined ? err.detail : err.response?.data?.detail;

    if (detail === RECAPTCHA_V2_REQUIRED) {
      const error = new Error('reCAPTCHA verification needed');
      error.code = RECAPTCHA_V2_REQUIRED;
      throw error;
    }

    if (Array.isArray(detail)) {
      const first = detail[0];
      if (typeof first === 'object' && first !== null) {
        const msg = first.msg || first.message || first.errorMessage || first.error;
        throw new Error(msg || 'An unexpected error occurred. Please try again.');
      }
      throw new Error(typeof first === 'string' ? first : 'An unexpected error occurred. Please try again.');
    }

    if (detail !== null && typeof detail === 'object') {
      const msg = detail.msg || detail.message || detail.errorMessage || detail.error;
      throw new Error(msg || 'An unexpected error occurred. Please try again.');
    }

    if (typeof detail === 'string' && detail.trim()) {
      throw new Error(detail);
    }

    console.error(err);
    throw new Error('An unexpected error occurred. Please try again.');
  }
}
